
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/framebuffer",
      function () {
        return require("private-next-pages/framebuffer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/framebuffer"])
      });
    }
  